<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
      <nav class="" id="by_header ">
    <h1 >
      <span v-on:click="ichiran" style="cursor: pointer;">
        
        <img v-if="header_logo" id="vy-logo" v-bind:src="header_logo" alt="ボラ活エール"/>
        <img v-else id="vy-logo" src="../../images/logo.png" alt="ボラ活エール" style="width:100%;height:auto" />

        <div style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        text-align: center;">
            <b :style="title_style1">{{ header_title1 }}</b>
            <b :style="title_style2">{{ header_title2 }}</b>
            </div>
      </span>
      
      <br/>
        <button v-if="moshikomi_ok == 1"  class="btn btn-primary mx-aut" style="width: 100%; height: 50px;padding: 0;" v-on:click="moshikomi" >申込む</button>
    </h1>

      </nav>
</template>


<script setup>

  /* eslint-disable */
  /* 変数の記述 */
  import { useRouter,useRoute } from 'vue-router'
import { shallowRef, watch, ref,nextTick } from 'vue'
  let router = useRouter()
  let route = useRoute()
  
  const cityname = route.params.shakyo

  const props = defineProps(['param']);
  const header_logo = props.param.header_logo
  const header_title1 = props.param.header_title1
  const header_title2 = props.param.header_title2
  const title_style1 = props.param.title_style1
  const title_style2 = props.param.title_style2
  /*
  param_left = {header_logo:header_logo,
                headet_title1:header_title1,
                headet_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
  */
  // 親（User）から送られたフラグによって申込ボタンの表示・非表示を変える（moshikomi_ok = 0：不可、1：可能）
  let moshikomi_ok = ref(0)
  if(props.param.moshikomi_ok){
      moshikomi_ok.value = props.param.moshikomi_ok
  } 

  // 親コンポーネントに送る値
  const emit = defineEmits(['call'])
  let moshikomi = function(){
    emit('call',{cmd:'shosai_moshikomi'});

  }

  const ichiran = function() {
    router.push("/"+cityname+"/Taiken" )
  }
</script>

<style scoped>

</style>